<template>
    <div class="row">
        <div class="col-lg-6 col-md-6">
            <user-card>

            </user-card>
        </div>
        <div class="col-lg-6 col-md-6">
            <edit-profile-form>

            </edit-profile-form>

        </div>
    </div>
</template>
<script>
  import EditProfileForm from './UserProfile/EditProfileForm.vue'
  import UserCard from './UserProfile/UserCard.vue'
  export default {
    components: {
      EditProfileForm,
      UserCard
    }
  }

</script>
<style>
    .centerDiv {
        margin: 0 auto;
    }
</style>



// WEBPACK FOOTER //
// UserProfile.vue?63ca9bdd